module.exports = __webpack_public_path__ + "img/watermark-detection@2x.b316bd2e.png";